import React from 'react';
import styled from 'styled-components';

import { useContactModalState } from '../hooks';

const MustCallWarning: React.FC = () => {
  const [contactModalState] = useContactModalState();
  const { isMustCallDisabled } = contactModalState;

  if (!isMustCallDisabled) return null;

  return (
    <StyledWarningText>
      Must call has been disabled because auto-confirm all showings has been
      selected. If you wish to enable must call, please choose another approval
      type.
    </StyledWarningText>
  );
};

export default MustCallWarning;

const StyledWarningText = styled.span`
  font-size: 12px;
  color: red;
  font-weight: 400;
  padding-right: 26px;
`;
